"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var IntegrationServerHelper = /** @class */ (function () {
    function IntegrationServerHelper() {
        this.cachedInstances = {};
        this.ajaxProvider = (0, AjaxProvider_1.default)("/api");
    }
    IntegrationServerHelper.prototype.getList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, list, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            pagination: { page: 1, perPage: 5 },
                            sort: { field: "id", order: "ASC" },
                            filter: {}
                        };
                        list = [];
                        return [4 /*yield*/, this.ajaxProvider.getList("app-integration-servers", params)];
                    case 1:
                        response = _a.sent();
                        response.data.forEach(function (result) {
                            list.push(IntegrationServerHelper.hydrate(result));
                        });
                        return [2 /*return*/, list];
                }
            });
        });
    };
    IntegrationServerHelper.prototype.getById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var params = { id: id };
                        _this.ajaxProvider.getOne("app-integration-servers", params)
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            .then(function (response) {
                            var template = IntegrationServerHelper.hydrate(response.data);
                            if (template) {
                                _this.cachedInstances[id] = template;
                                resolve(_this.cachedInstances[id]);
                            }
                        }).catch(function (e) {
                            {
                                reject(e);
                            }
                        });
                    })];
            });
        });
    };
    IntegrationServerHelper.prototype.getState = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response, body, info, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("/api/app-integration-servers/" + id + "/state")];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        info = {
                            id: id,
                            worker: body.data.worker,
                            workers_running: 0,
                            workers_max: 0,
                            workers_active: 0,
                        };
                        for (i in info.worker) {
                            info.workers_max++;
                            info.worker[i].started = info.worker[i].started ? new Date(info.worker[i].started) : undefined;
                            info.worker[i].active = info.worker[i].active ? new Date(info.worker[i].active) : undefined;
                            info.worker[i].exited = info.worker[i].exited ? new Date(info.worker[i].exited) : undefined;
                            if (info.worker[i].started) {
                                if (!info.worker[i].exited || info.worker[i].exited < info.worker[i].started) {
                                    if (info.worker[i].active) {
                                        info.workers_active++;
                                    }
                                    info.workers_running++;
                                }
                            }
                        }
                        return [2 /*return*/, info];
                }
            });
        });
    };
    IntegrationServerHelper.prototype.getStats = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("/api/app-integration-servers/" + id + "/stats")];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, body.data];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    IntegrationServerHelper.hydrate = function (data) {
        return {
            id: data.id,
            identifier: data.identifier,
            name: data.name,
            management_access: data.management_access,
            resource_access: data.resource_access,
            player_host: "",
            player_psk: "",
            expected_heartbeat_freq: data.expected_heartbeat_freq,
            first_heartbeat_at: data.first_heartbeat_at ? new Date(data.first_heartbeat_at) : undefined,
            last_heartbeat_at: data.last_heartbeat_at ? new Date(data.last_heartbeat_at) : undefined,
            private: data.private,
            created_at: new Date(data.created_at),
            updated_at: data.updated_at ? new Date(data.updated_at) : undefined,
            deleted_at: data.deleted_at ? new Date(data.deleted_at) : undefined,
        };
    };
    return IntegrationServerHelper;
}());
var integrationServerHelper = new IntegrationServerHelper();
exports.default = integrationServerHelper;
